$(document).on("click", ".ProductForm__AddToCart.coll_page", function () {
  var get_id = $(this).parents(".Grid__Cell").find(".dropdown span.select-label").attr("value");
  var ID = $(this).attr("data-add-to-cart-id");
  var qty = parseInt($(this).parents(".Grid__Cell").find("input.quantity-selector.quantity-input").val());
  if (typeof get_id != "undefined" && get_id != 0) {
    data = {
      id: ID,
      selling_plan: get_id,
      quantity: qty
    };
  } else {
    data = {
      id: ID,
      quantity: qty
    };
  }
  if (get_id == 0) {
    data = {
      id: ID,
      quantity: qty
    };
  }

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (productid) {
      document.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: productid
          }
        })
      );
    }
  });
});
$("body").click(function (evt) {
  if ($(evt.target).closest("span.select-label").length > 0) {
  } else {
    $(".dropdown").removeClass("active");
  }
});
$(document).ready(function () {
  $("ul.dropdown-list").each(function () {
    var get_first = $(this).find("li:first").html();
    var get_value = $(this).find("li:first").attr("value");

    $(this).parents(".Grid__Cell").find("span.select-label").attr("value", get_value);
    $(this).parents(".Grid__Cell").find("span.select-label").html(get_first);
  });
  $(document).on("click", ".select-label", function () {
    var $this = $(this);
    if ($this.parents(".Grid__Cell").children(".dropdown").hasClass("active")) {
      $this.parents(".Grid__Cell").children(".dropdown").toggleClass("active");
    } else {
      $(".dropdown").removeClass("active");
      $this.parents(".Grid__Cell").children(".dropdown").toggleClass("active");
    }
  });

  $(document).on("click", ".dropdown-list li", function () {
    $(this).parents(".Grid__Cell").find(".select-label").html($(this).html());
    $(this).parents(".Grid__Cell").find(".select-label").attr("value", $(this).val());
    $(this).parents(".Grid__Cell").find(".dropdown").removeClass("active");
  });
});

$(document).on("click", ".qtybox .btnqty", function () {
  var qty = parseInt($(this).parent(".qtybox").find(".quantity-input").val());
  if ($(this).hasClass("qtyplus")) {
    qty++;
  } else {
    if (qty > 1) {
      qty--;
    }
  }
  qty = isNaN(qty) ? 1 : qty;
  $(this).parent(".qtybox").find(".quantity-input").val(qty);
});

// if ($(window).width() < 960) {
//   $('.logo-container').slick({
//   infinite: true,
//   slidesToShow: 2,
//   slidesToScroll: 1,
//   arrows: true,
//   });
// }

$(document).ready(function () {
  // $(window).resize(function(){
  // if($(window).width() < 960) {
  $(".logo-container").slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      "<img class='a-left control-c prev slick-prev' src='https://img.icons8.com/ios/20/000000/forward--v1.png'>",
    nextArrow:
      "<img class='a-right control-c next slick-next' src='https://img.icons8.com/ios/20/000000/forward--v1.png'>",
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  });
  // } else {
  //   $('.logo-container').slick('unslick');
  // }
  // });
});

$(function () {
  var urlll = $(".bundle-spices-wrap .bundle_grid").length;
  if (urlll == 0) {
    $(".all_products input").each(function () {
      var handle = $(this).val();
      if (handle != "") {
        var url = "/products/" + handle + "?view=spices";
        var path = $(".all_products input[data-handle='" + handle + "']").attr("data-image");
        $.ajax({
          url: url,
          type: "GET",
          dataType: "html"
        })
          .done(function (data) {
            $(".bundle-spices-wrap").append(data);
            $(".bundle-spices-wrap .bundle_grid[data-handle='" + handle + "']").attr("data-image", path);
          })
          .fail(function (data) {})
          .always(function (data) {});
      }
    });
  }
  spiceData = [];
  finalSpices = [];
  var availableData = "";
  var arrString = "";
  var desiredData = "";
  var length = "";
  var sumtext = "";
  var spicesToadd = "";
  var selected_size = $(".SizeSwatchList li input[name='option-0']:checked").val();

  function spicedata(dataid) {
    var selected_size = $(".SizeSwatchList li input[name='option-0']:checked").val();
    spiceData.push(dataid);
    var check_exist = $("body").hasClass("custom_eight_pack_rack");
    if (check_exist == true) {
      spicesToadd = 8;
      $(".limit").text("8");
    } else {
      if (selected_size == "Core") {
        spicesToadd = 12;
        $(".limit").text("12");
      } else {
        spicesToadd = 18;
        $(".limit").text("18");
      }
    }
    length = spiceData.length;
    if (length == spicesToadd) {
      $(".add_spices, .add").attr("disabled", "disabled");
      $(".bundleAtc").removeAttr("disabled");
      arrString = spiceData.join(", ");
    }
  }
  function qty_check(spicesToadd) {
    var summ = 0;
    $(".bundle__QuantitySelector:visible").each(function () {
      var qtyy = $(this).find(".selected_qty").val();
      var sum = parseInt(qtyy);
      summ += sum || 0;
    });
    sumtext = spicesToadd - summ;
    $(".current_barcount, .total_needed .currentVal").text(summ);
    $(".addmore").text(sumtext);
    var progress = (summ / spicesToadd) * 100;
    $("#myBar").width(progress + "%");
    sumtext = spicesToadd - summ;
    if (summ == spicesToadd) {
      $(".add_spices, .add").attr("disabled", "disabled");
      $(".bundleAtc").removeAttr("disabled");
      $(".hidetext").hide();
      $(".completed_jar,.spices_bar p img ").show();
    }
  }

  function remainingCheck(spicesToadd) {
    var summ = 0;
    $(".bundle__QuantitySelector:visible").each(function () {
      var qtyy = $(this).find(".selected_qty").val();
      var sum = parseInt(qtyy);
      summ += sum || 0;
    });
    sumtext = spicesToadd - summ;
    $(".selection_container_left-item_first").text(summ + " Spices Selected");
    $(".selection_container_left-item_last").text(sumtext);
    $(".custom-sticky-bundle-image").attr("value", summ);
    const stickyBottomBundle = $(".sticky_bottom_bundle_strip");
    if (stickyBottomBundle) {
      stickyBottomBundle.toggleClass("open", summ > 0);
    }
  }

  function imgfill(data_image, data_title) {
    var i = 0;
    $(".bundle-form--image-slot").each(function () {
      if ($(this).hasClass("empty")) {
        if (i == 0) {
          $(this).find("img").attr("src", data_image);
          $(this).removeClass("empty").addClass("filled").attr("data-title", data_title);
          i++;
          return false;
        }
      }
    });

    var j = 0;
    $(".bundle-form--image-slot-sticky").each(function () {
      if ($(this).hasClass("empty")) {
        if (j == 0) {
          $(this).find(".spice-image").attr("src", data_image);
          $(this).find(".select-data-title").text(data_title);
          $(this).removeClass("empty").addClass("filled").attr("data-title", data_title);
          j++;
          return false;
        }
      }
    });
  }

  function getdata() {
    var arrData = [];
    $(".bundle-form--image-slot").each(function () {
      var data_title = $(this).attr("data-title");
      var data_image = $(this).find("img").attr("src");
      if (data_image != "" && data_title != "") {
        arrData.push({
          data_title: data_title,
          data_image: data_image
        });
      }
    });
    var k = 0;
    $(".bundle-form--image-slot").each(function () {
      if (typeof arrData[k] != "undefined") {
        $(this).attr("data-title", arrData[k]["data_title"]).removeClass("empty").addClass("filled");
        $(this).find("img").attr("src", arrData[k]["data_image"]);
      } else {
        $(this).attr("data-title", "").removeClass("filled").addClass("empty");
        $(this).find("img").attr("src", "");
      }
      k++;
    });

    var j = 0;
    $(".bundle-form--image-slot-sticky").each(function () {
      if (typeof arrData[j] != "undefined") {
        $(this).attr("data-title", arrData[j]["data_title"]).removeClass("empty").addClass("filled");
        $(this).find(".spice-image").attr("src", arrData[j]["data_image"]);
        $(this).find(".select-data-title").text(arrData[j]["data_title"]);
      } else {
        $(this).attr("data-title", "").removeClass("filled").addClass("empty");
        $(this).find(".spice-image").attr("src", "");
        $(this).find(".select-data-title").text("");
      }
      j++;
    });
  }

  $(document).on("click", ".add_spices", function (e) {
    $(this).hide();
    var selected_size = $(".SizeSwatchList li input[name='option-0']:checked").val();
    var check_exist = $("body").hasClass("custom_eight_pack_rack");
    if (check_exist == true) {
      spicesToadd = 8;
      $(".limit").text("8");
    } else {
      if (selected_size == "Core") {
        spicesToadd = 12;
        $(".limit").text("12");
      } else {
        spicesToadd = 18;
        $(".limit").text("18");
      }
    }
    var data_image = $(this).parents(".bundle_grid").attr("data-image");
    var data_title = $(this).parents(".bundle_grid").attr("data-title");

    var value = $(this).next().find(".selected_qty").val();

    if (value == 0) {
      $(this).next().find(".add").click();
    } else {
      getdata();
      imgfill(data_image, data_title);
    }
    $(this).next(".bundle__QuantitySelector").show();
    e.preventDefault();
    qty_check(spicesToadd);
    remainingCheck(spicesToadd);
  });

  $(document).on("click", ".icon--clear-bundle", function () {
    var selectedsize = $(".SizeSwatchList li input[name='option-0']:checked").val();
    var datatitle = $(this).parents(".bundle-form--image-slot").attr("data-title");

    $('.bundle_grid[data-title="' + datatitle + '"]')
      .find(".sub")
      .click();

    var check_exist = $("body").hasClass("custom_eight_pack_rack");
    if (check_exist == true) {
      spicesToadd = 8;
    } else {
      if (selectedsize == "Core") {
        spicesToadd = 12;
      } else {
        spicesToadd = 18;
      }
    }
    remainingCheck(spicesToadd);
  });

  $(document).on("click", ".icon--clear-bundle-custom", function () {
    var selectedsize = $(".SizeSwatchList li input[name='option-0']:checked").val();
    var datatitle = $(this).parents(".bundle-form--image-slot-sticky").attr("data-title");

    $('.bundle_grid[data-title="' + datatitle + '"]')
      .find(".sub")
      .click();

    var check_exist = $("body").hasClass("custom_eight_pack_rack");
    if (check_exist == true) {
      spicesToadd = 8;
    } else {
      if (selectedsize == "Core") {
        spicesToadd = 12;
      } else {
        spicesToadd = 18;
      }
    }
    remainingCheck(spicesToadd);
  });

  $(document).on("click", ".bundleAtc", function (event) {
    event.preventDefault();

    var numarray = [];

    $(".bundle__QuantitySelector:visible").each(function () {
      var num = $(this).find("input").val();
      var ingr = $(this).find(".add").attr("data-title");

      if (num > 0) {
        for (var i = 0; i < num; i++) {
          numarray.push(ingr);
        }
      }
    });
    arrString = numarray.join(", ");

    var id = $(".Select select option:selected").attr("value");
    if (!id) {
      id = $('input[name="id"]').val();
    }
    var addData = {
      id: id,
      quantity: 1,
      properties: {
        SPICES: arrString
      }
    };
    var selling_plan_id = $('.custombundle_wrapper [name="selling_plan"]').val();
    if (selling_plan_id) {
      addData.selling_plan = selling_plan_id;
    }
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify(addData),
      contentType: "application/json",
      dataType: "json",
      success: function (addedData) {
        window.location.href = "/checkout";
      },
      error: function () {}
    });
  });

  function preselected() {
    var i = 0;
    $(".precheckedproducts p").each(function () {
      var exist = $(this).attr("data-precheck");
      if (exist == "true") {
        $(".bundle-spices-wrap .bundle_grid").eq(i).find(".add_spices").trigger("click");
      }
      i++;
    });
  }

  $(document).on("click", '.custombundle_wrapper .ProductForm__Variants input[name="option-0"]', function () {
    $(".bundle-form--image-slot, .bundle-form--image-slot-sticky").removeClass("filled").addClass("empty");
    $(".bundle__QuantitySelector,.completed_jar,.spices_bar p img").hide();
    $(".add_spices,.hidetext").show();
    $(".selected_qty").val(0);
    $(".bundle-form--image-slot img, .bundle-form--image-slot-sticky .spice-image").attr("src", "");
    $(".select-data-title").text("");
    setTimeout(function () {
      preselected();
    }, 1000);
    var selectedsize = $(".SizeSwatchList li input[name='option-0']:checked").val();
    var check_exist = $("body").hasClass("custom_eight_pack_rack");
    if (check_exist == true) {
      var spicesToadd = 8;
    } else {
      if (selectedsize == "Core") {
        var spicesToadd = 12;
      } else {
        var spicesToadd = 18;
      }
    }
    remainingCheck(spicesToadd);
    setTimeout(function () {
      if ($("#em001-btn-2-checkout-2").length) {
        var currPrice = $(".top_price .ProductMeta__Price").text();
        $("#em001-btn-2-checkout-2").html(`<span>Add to Bag - ${currPrice}</span>`);
      }
    }, 1100);
  });

  $(document).on("click", ".custombundle_wrapper .ProductForm__Variants input", function () {
    $(".Select select option").removeAttr("selected", "selected");
    var text = "";
    $(".custombundle_wrapper .ProductForm__Option li.HorizontalList__Item input").each(function () {
      if ($(this).is(":checked")) {
        text += $(this).val() + " / ";
      }
    });
    var newname = text.slice(0, -2).trim();
    $(".Select select option[data-title='" + newname + "']").attr("selected", "selected");

    // Change image in `.bottom_strip .variant-image img` with `.variant-left img`
    var variantImageSrc = $(this).siblings(".variant-rack-container").find(".variant-left img").attr("src");

    if (variantImageSrc) {
      $(".bottom_strip .variant-image img").attr("src", variantImageSrc);
      $(".bottom_strip .variant-image img").attr("srcset", variantImageSrc);
    }

    var selectedsize = $(".SizeSwatchList li input[name='option-0']:checked").val();

    var selectedColor = $(".ColorSwatchList li input[name='option-1']:checked").val();

    var getCustomSize = $(".option_variant_custom-detail.custom-size");
    var getCustomColor = $(".option_variant_custom-detail.custom-color");

    if (getCustomSize.length) {
      if (selectedsize === "Complete" || selectedsize === "Core") {
        getCustomSize.text(selectedsize + " Rack");
      } else {
        getCustomSize.text(selectedsize);
      }
    }

    if (getCustomColor.length) {
      getCustomColor.text(selectedColor);
    }

    var check_exist = $("body").hasClass("custom_eight_pack_rack");
    if (check_exist == true) {
      spicesToadd = 8;
      $(".custombundle_wrapper").addClass("two-tier");
      $(".custombundle_wrapper").removeClass("three-tier");
    } else {
      if (selectedsize == "Core") {
        spicesToadd = 12;
        $(".custombundle_wrapper").addClass("two-tier");
        $(".custombundle_wrapper").removeClass("three-tier");
      } else {
        spicesToadd = 18;
        $(".custombundle_wrapper").addClass("three-tier");
        $(".custombundle_wrapper").removeClass("two-tier");
      }
    }
    setTimeout(function () {
      var currPrice = $(".top_price .ProductMeta__Price").text();
      $(".bottom_strip .ProductMeta__Price").text(currPrice);
      $(".custombundle_wrapper .ProductForm__AddToCart").addClass("bundleAtc").attr("disabled", "disabled");
      var check_exist = $("body").hasClass("custom_eight_pack_rack");
      if (check_exist == true) {
        $(".limit,.choose_spice, .selection_container_left-item_last").text("8");
      } else {
        if (spicesToadd == 18) {
          $(".limit,.choose_spice, .selection_container_left-item_last").text("18");
        } else {
          $(".limit,.choose_spice, .selection_container_left-item_last").text("12");
        }
      }
      var summ = 0;
      $(".bundle__QuantitySelector:visible").each(function () {
        var qtyy = $(this).find(".selected_qty").val();
        var sum = parseInt(qtyy);
        summ += sum || 0;
      });
      sumtext = spicesToadd - summ;
      $(".addmore").text(sumtext);
      if (summ == spicesToadd) {
        $(".custombundle_wrapper .ProductForm__AddToCart").text("Add To Cart");
        $(".custombundle_wrapper .ProductForm__AddToCart").removeAttr("disabled");
      } else {
        $(".add_spices, .add").removeAttr("disabled");
      }
    }, 200);
  });

  $(document).on("click", ".add", function () {
    var selectedsize = $(".SizeSwatchList li input[name='option-0']:checked").val();
    var check_exist = $("body").hasClass("custom_eight_pack_rack");
    if (check_exist == true) {
      var spicesadd = 8;
      $(".limit").text("8");
    } else {
      if (selectedsize == "Core") {
        var spicesadd = 12;
        $(".limit").text("12");
      } else {
        var spicesadd = 18;
        $(".limit").text("18");
      }
    }
    if ($(this).prev().val() < spicesadd) {
      $(this)
        .prev()
        .val(+$(this).prev().val() + 1);
    }

    var data_image = $(this).parents(".bundle_grid").attr("data-image");
    var data_title = $(this).parents(".bundle_grid").attr("data-title");
    qty_check(spicesToadd);
    remainingCheck(spicesToadd);
    getdata();
    imgfill(data_image, data_title);
  });

  $(document).on("click", ".sub", function () {
    if ($(this).next().val() > 0) {
      if ($(this).next().val() > 0)
        $(this)
          .next()
          .val(+$(this).next().val() - 1);
    }
    if ($(this).next().val() == 0) {
      $(this).parents(".bundle__QuantitySelector").hide();
      $(this).parents(".bundle__QuantitySelector").prev().show();
    }
    var dataid = $(this).data("title");
    var selected_size = $(".SizeSwatchList li input[name='option-0']:checked").val();
    var summ = 0;
    var check_exist = $("body").hasClass("custom_eight_pack_rack");
    if (check_exist == true) {
      spicesToadd = 8;
      $(".limit").text("8");
    } else {
      if (selected_size == "Core") {
        spicesToadd = 12;
        $(".limit").text("12");
      } else {
        spicesToadd = 18;
        $(".limit").text("18");
      }
    }
    $(".bundle__QuantitySelector:visible").each(function () {
      var qtyy = $(this).find(".selected_qty").val();
      var sum = parseInt(qtyy);
      summ += sum || 0;
    });
    $(".current_barcount, .total_needed .currentVal").text(summ);
    var progress = (summ / spicesToadd) * 100;
    $("#myBar").width(progress + "%");
    sumtext = spicesToadd - summ;
    $(".addmore").text(sumtext);
    if (summ < spicesToadd) {
      $(".hidetext").show();
      $(".completed_jar,.spices_bar p img").hide();
      $(".bundleAtc").attr("disabled", "disabled");
      $(".add_spices, .add").removeAttr("disabled");
    }

    var testarr = [];
    $(".bundle-form--image-slot").each(function (index, value) {
      if ($(this).attr("data-title").indexOf(dataid) > -1) {
        testarr.push(index);
      }
    });

    var last_element = testarr[testarr.length - 1];
    $(".image-slot-" + last_element + "")
      .attr("data-title", "")
      .removeClass("filled")
      .addClass("empty");
    $(".image-slot-" + last_element)
      .find("img")
      .attr("src", "");
    getdata();
    remainingCheck(spicesToadd);
  });

  /************ Progress Bar *********/
  var currentCount = $(".current_barcount").text();
  var check_exist = $("body").hasClass("custom_eight_pack_rack");
  if (check_exist == true) {
    spicesToadd = 8;
    $(".limit,.choose_spice, .selection_container_left-item_last").text("8");
    $(".custombundle_wrapper").addClass("two-tier");
    $(".custombundle_wrapper").removeClass("three-tier");
  } else {
    if (selected_size == "Core") {
      spicesToadd = 12;
      $(".limit,.choose_spice, .selection_container_left-item_last").text("12");
      $(".custombundle_wrapper").addClass("two-tier");
      $(".custombundle_wrapper").removeClass("three-tier");
    } else {
      spicesToadd = 18;
      $(".limit,.choose_spice, .selection_container_left-item_last").text("18");
      $(".custombundle_wrapper").addClass("three-tier");
      $(".custombundle_wrapper").removeClass("two-tier");
    }
  }
  var progress = (currentCount / spicesToadd) * 100;
  $("#myBar").width(progress + "%");

  /************* Spices Ajax search *************/
  $("#myInput").on("keyup", function () {
    var value = $(this).val().toLowerCase();
    $(".bundle-spices-wrap .bundle_grid").filter(function () {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    });
  });
  $(".bundle_grid").each(function () {
    var text = $(this).find("p").text();
    text = text.replace("Jar", "");
    $(this).find("p").text(text);
  });
});

$(window).on("load", function () {
  var i = 0;
  $(".precheckedproducts p").each(function () {
    var exist = $(this).attr("data-precheck");
    if (exist == "true") {
      $(".bundle-spices-wrap .bundle_grid").eq(i).find(".add_spices").trigger("click");
      $(".spices_bar").show();
    }

    i++;
  });
});
$(window).on("load resize", function (e) {
  jQuery(document).ready(function ($) {
    var header_height = jQuery("div#shopify-section-header").height();
    var bar_height = jQuery("div#shopify-section-announcement").height();
    var total_height = header_height + bar_height;
    jQuery(".Product__Wrapper .bundle_left_content").css("top", header_height);
  });
});

/* show popup product*/
$(function () {
  $(".show-popup").click(function () {
    $(".cover").fadeIn("300");
    $("body").addClass("openPopup");
  });

  $(".Product__Info .cover, .Product__Info .close").click(function () {
    $(".cover").fadeOut("300");
    $("body").removeClass("openPopup");
  });

  $(".Product__Info .contents").click(function (e) {
    e.stopPropagation();
  });
});

$(function () {
  $("body").on("click", ".shopify_explorer_faq__question", function () {
    $(this).next(".shopify_explorer_faq__answer").slideToggle(150).toggleClass("active");
    $(this).toggleClass("active");
  });

  $(document).on("shopify:block:select", "#shopify-section-page-shopify_explorer_faq-template", function (event) {
    $(event.target).find(".shopify_explorer_faq__answer").slideDown(150);
  });

  $(document).on("shopify:block:deselect", "#shopify-section-page-shopify_explorer_faq-template", function (event) {
    $(event.target).find(".shopify_explorer_faq__answer").slideUp(150);
  });
});

// Sticky
$(document).ready(function () {
  // Toggle class on selection_container click
  $(".selection_container").on("click", function () {
    $(this).closest(".sticky_bottom_bundle_strip").toggleClass("open");
  });

  // Horizontal scroll functionality
  const $scrollContainer = $(".custom-sticky-bundle-image");
  let isDown = false;
  let startX;
  let scrollLeft;

  $scrollContainer.on("mousedown", function (e) {
    isDown = true;
    $scrollContainer.addClass("active");
    startX = e.pageX - $scrollContainer.offset().left;
    scrollLeft = $scrollContainer.scrollLeft();
    $scrollContainer.css("cursor", "grabbing");
  });

  $(document).on("mouseup", function () {
    isDown = false;
    $scrollContainer.removeClass("active");
    $scrollContainer.css("cursor", "grab");
  });

  $scrollContainer.on("mouseleave", function () {
    isDown = false;
    $scrollContainer.removeClass("active");
    $scrollContainer.css("cursor", "grab");
  });

  $scrollContainer.on("mousemove", function (e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - $scrollContainer.offset().left;
    const walk = x - startX;
    $scrollContainer.scrollLeft(scrollLeft - walk);
  });
});

$(document).ready(function () {
  var maxWaitTime = 10000;
  var elapsedTime = 0;
  var checkInterval = 100;

  var checkExist = setInterval(function () {
    elapsedTime += checkInterval;

    if ($("#em001-btn-2-checkout-2").length) {
      var currPrice = $(".top_price .ProductMeta__Price").text();
      $("#em001-btn-2-checkout-2").html(`<span>Add to Bag - ${currPrice}</span>`);

      clearInterval(checkExist);
    }

    if (elapsedTime >= maxWaitTime) {
      clearInterval(checkExist);
    }
  }, checkInterval);

  $(document).on("click", ".variant-display_change", function () {
    $("html, body").animate(
      {
        scrollTop: $(".ProductForm__Variants").offset().top - 200
      },
      500
    );
  });
});

$(document).ready(function () {
  if ($(".Product__Wrapper .rating-count") && $(".junip-product-review")) {
    $(".Product__Wrapper .rating-count").css("cursor", "pointer");

    $(".Product__Wrapper .rating-count").on("click", function () {
      $("html, body").animate(
        {
          scrollTop: $(".junip-product-review").offset().top - 200
        },
        1000
      );
    });
  }
});
